import { getInclusionOptions } from '../logicHelpers'

const deviceSource = () => ({
  types: [
    { label: 'Operating System', value: 'os', description: 'Windows, macOS, iOS, Android…' },
    { label: 'Browser', value: 'browser', description: 'Chrome, Safari, Firefox…' }
  ],
  inputs: [
    {
      control: 'select',
      key: 'device-operator-select',
      name: 'operator',
      options: getInclusionOptions(),
      can: (condition: { $source: string; $type: string }) => condition.$source === 'device'
    },
    {
      control: 'multiselect',
      key: 'device-os-value-input',
      multiple: true,
      name: 'value',
      options: [
        ...['iOS', 'Android', 'Windows', 'MacOS', 'Linux'].map((os) => ({
          label: os,
          value: os
        }))
      ],
      can: (condition: { $source: string; $type: string; operator: string }) =>
        condition.$source === 'device' &&
        condition.$type === 'os' &&
        condition.operator !== 'is set' &&
        condition.operator !== 'is not set'
    },
    {
      control: 'multiselect',
      key: 'device-browser-value-input',
      multiple: true,
      name: 'value',
      options: [
        ...['Chrome', 'Firefox', 'Safari', 'Edge', 'Opera'].map((browser) => ({
          label: browser,
          value: browser
        }))
      ],
      can: (condition: { $source: string; $type: string; operator: string }) =>
        condition.$source === 'device' &&
        condition.$type === 'browser' &&
        condition.operator !== 'is set' &&
        condition.operator !== 'is not set'
    }
  ]
})

export default deviceSource
